var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconMacros = function SvgIconMacros(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 18v-4.594l5.97-3.237V3.322L11 1v11.577zM23 18l-10-5.423V1l4.03 2.322v6.847L23 13.406zM18.025 21.894l-6.108-3.362L5.924 22 2 19.711 11.868 14 22 19.576z"
  }))));
};

export default __webpack_public_path__ + "static/media/icon-macros.56d09f45.svg";
export { SvgIconMacros as ReactComponent };